export enum Condition {
    NoDiseases = 0,
    High_Blood_Pressure = 170,
    High_Cholesterol = 180,
    Diabetes_Type_1 = 185,
    Diabetes_Type_2 = 190,
    Cardiovascular_Disease = 210,
    Cancer = 220,    
    Tobacco_Usage = 150,
    Obesity = 300,
    //PTSD = 280,
    Parkinsons_Disease = 240,
    //Amputations = 290
    Alzheimers = 230
}
